import { useNavigate } from 'react-router-dom';

import {
  Button,
  Card,
  CardContent,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  Carousel,
} from 'alm-react-components';
import { useTranslation } from 'react-i18next';
import useDailyReminderHook from '../../../hooks/useDailyReminderHook';
import { APPROUTES, constants } from '../../../assets/constants/constants';
import remindersIconImg from "../../../assets/images/svgicons/reminders-icon.svg";

import { useState } from 'react';
import DailyReminderModal from '../../common/DailyReminderModal';

const DailyReminderSection = () => {
  const { dailyReminderData } = useDailyReminderHook();
  const { t } = useTranslation();
  const [fulltext, setFullText] = useState(false);
  const [dailyReminderText, setDailyReminderText] = useState("");
  const navigate = useNavigate();





  return (
    <>
      <div className="mt-14 mb-14 xl:px-32 lg:px-8 md:px-8 px-5">
        <div className="flex flex-wrap justify-between md:flex-nowrap">
          <h2 className="text-3xl font-barlowLight pl-2 max-md:mb-4">
            <span dangerouslySetInnerHTML={{ __html: (t('MyStance.dailyReminder')) }} /></h2>
          <Button
            variant="outline"
            onClick={() => navigate(`/daily-reminders`, { state: { from: APPROUTES.library } })}
            className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard border-0"
          >
            <span dangerouslySetInnerHTML={{ __html: (t('Common.seeAll')) }} />
          </Button>
        </div>
        <Carousel className="mt-8 md:mt-12">
          {dailyReminderData && dailyReminderData?.length > 0 ? (
            <>
              <CarouselContent className="g:flex-row lg:gap-0 md:gap-0 md:flex md:flex-row">
                {dailyReminderData && dailyReminderData.slice(0, constants.SEE_MORE_LIMITS)?.map((res: any) => {
                  return (
                    <>
                      <CarouselItem className="landscape:2xl:basis-1/4 landscape:xl:basis-1/4 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2">
                        <Card className="dark:card-gradient-gray dark:text-white dark:border-0 rounded-2xl pt-9 pb-8 h-full relative flex items-center justify-center">
                          <CardContent className="pt-4">
                            <div className=" justify-center flex pb-4">
                              <img src={remindersIconImg} alt={" "} className="logo text-sm w-[23px] h-[18px]" />
                            </div>
                            <p className="text-base font-barlowLight text-primary leading-tight pb-6 text-center break-words select-none">
                              {res?.description.length > constants.DAILYREMINDER_LIMIT ? res?.description?.slice(0, constants.DAILYREMINDER_LIMIT) + "..." : res?.description}
                            </p>
                            {res?.description?.length > constants.DAILYREMINDER_LIMIT &&
                              <p onClick={() => { setDailyReminderText(res?.description.length > constants.DAILYREMINDER_LIMIT && (res?.description)); setFullText(res?.description.length > constants.DAILYREMINDER_LIMIT ? true : false) }} className="text-center cursor-pointer">
                                <span dangerouslySetInnerHTML={{ __html: (t('Common.seeMore')) }} /></p>}
                            <div className="flex items-center justify-end absolute bottom-[10px] right-[10px]">
                              <div className="flex-shrink-0 inline-flex items-center text-base font-opensansSemiBold text-gray-900 dark:text-white">
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      </CarouselItem>
                    </>
                  );
                })}
                {dailyReminderData.length > constants.SEE_MORE_LIMITS && (
                  <CarouselItem className="landscape:2xl:basis-1/4 landscape:xl:basis-1/4 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2 landscape:sm:basis-1/2 portrait:sm:basis-1/2 md:pl-5">
                    <Card
                      onClick={() => navigate('/daily-reminders')}
                      className="w-full h-full p-0 bg-fillMidGrayCard cursor-pointer border-cardBorder relative flex items-center justify-center"
                    >
                      <CardContent className="mt-4 px-5  ">
                        <div className="text-2xl"><span dangerouslySetInnerHTML={{ __html: (t('Common.seeMore')) }} /></div>
                      </CardContent>
                    </Card>
                  </CarouselItem>
                )}
              </CarouselContent>
              <div className="carousel-prev-next-box">
                <CarouselPrevious className="carousel-prev-btn top-full mt-5 translate-y-0" />
                <CarouselNext className="carousel-next-btn right-0 top-full bottom-0 mt-5 translate-y-0" />
              </div>
            </>
          ) : (
            <div className=" flex justify-center w-full text-2xl">
              <span dangerouslySetInnerHTML={{ __html: (t('MyStance.noDailyReminderFound')) }} />
            </div>
          )}
        </Carousel>
      </div>
      <DailyReminderModal fullText={fulltext} setFullText={setFullText} text={dailyReminderText} />
    </>
  );
};

export default DailyReminderSection;
